import Vue from 'vue'
import Router from 'vue-router'
import AboutUs from '../components/aboutUs'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [

        {
            path: '/',
            name: 'Index',
            component: AboutUs,
            // redirect: ""
        },

    ]
})
